
import {
    PartnerApiKey,
    Tour,
    Destination,
    Accommodation,
    Activity,
    Customer,
    Booking,
    Country,
    PaymentGateway,
    Payment,
    Role,
    AdminUser,
    BlogPost,
    Author,
    BlogCategory,
    BlogTag,
    Language,
    Currency,
    CentralEntity,
    RegionalEntity,
    ContentPage,
    SystemLog,
    CookiePolicy,
    Passenger,
    TourDeparture,
    TripDocument,
    NotificationLog,
    MediaFolder,
    MediaFile,
    Menu,
    SchemaMarkup,
    SeoMetaRecord,
    GmbLocation,
    LocalCitation,
    Review,
    EmailTemplate,
    Theme,
    NavItem,
    ScrapingJob,
    BlogContentCluster,
    BlogContentGap,
    SystemUpdate,
    UserChatSession,
    TrainingDocument,
    GmbAccount,
    SearchQueryStat,
    CrawlError,
    CoreWebVitalsMetric,
    SeoTrafficPoint,
    AnalyticsTrafficData,
    DeviceStat,
    TopPageStat,
    FunnelStep,
    UserPath,
    GeoStat,
    MaintenanceTask,
    Permission,
    SiteSettings,
    ContactOffice,
    ThemeSection
} from './types';
import {
    LayoutDashboard,
    Compass,
    MapPin,
    Users,
    Calendar,
    CreditCard,
    FileText,
    BarChart2,
    Settings,
    Globe,
    ShieldCheck,
    MessageSquare,
    Image as ImageIcon,
    Key,
    Activity as ActivityIcon,
    Search,
    Network,
    Building,
    Map,
    Bot
} from 'lucide-react';




export const NAV_ITEMS: NavItem[] = [
    { title: 'Dashboard', href: '/admin', icon: LayoutDashboard, permission: 'view_dashboard' },

    {
        title: 'Tours',
        href: '#',
        icon: Compass,
        permission: 'manage_tours',
        submenu: [
            { title: 'All Tours', href: '/admin/tours', permission: 'view_tours' },
            { title: 'Tour Types', href: '/admin/tour-categories', permission: 'manage_tour_categories' },
            { title: 'Departures', href: '/admin/tour-departures', permission: 'manage_tour_departures' },
            { title: 'Pricing Rules', href: '/admin/tour-pricings', permission: 'manage_tour_pricings' },
        ]
    },

    {
        title: 'Bookings',
        href: '#',
        icon: Calendar,
        permission: 'manage_bookings',
        submenu: [
            { title: 'All Bookings', href: '/admin/bookings', permission: 'view_bookings' },
            { title: 'Tour Operations', href: '/admin/tour-bookings', permission: 'manage_tour_operations' },
        ]
    },

    {
        title: 'Travel Data',
        href: '#',
        icon: Map,
        permission: 'manage_destinations',
        submenu: [
            { title: 'Countries', href: '/admin/countries', permission: 'manage_countries' },
            { title: 'Destinations', href: '/admin/destinations', permission: 'manage_destinations_list' },
            { title: 'Activities', href: '/admin/activities', permission: 'manage_activities' },
            { title: 'Activity Categories', href: '/admin/activity-categories', permission: 'manage_activity_categories' },
            { title: 'Accommodations', href: '/admin/accommodations', permission: 'manage_accommodations' },
        ]
    },

    {
        title: 'CRM & Finance',
        href: '#',
        icon: Users,
        permission: 'manage_customers',
        submenu: [
            { title: 'Customers', href: '/admin/customers', permission: 'view_customers' },
            { title: 'Payments', href: '/admin/payments', permission: 'manage_financials' },
            { title: 'Reviews', href: '/admin/reviews', permission: 'manage_reviews' },
            { title: 'Payment Gateways', href: '/admin/payment-gateways', permission: 'manage_payment_gateways' },
            { title: 'Currencies', href: '/admin/currencies', permission: 'manage_currencies' },
        ]
    },

    {
        title: 'Content Strategy',
        href: '#',
        icon: FileText,
        permission: 'manage_content',
        submenu: [
            { title: 'Blog Posts', href: '/admin/blog-posts', permission: 'manage_blog_posts' },
            { title: 'Categories', href: '/admin/blog-categories', permission: 'manage_blog_categories' },
            { title: 'Tags', href: '/admin/tags', permission: 'manage_tags' },
            { title: 'Static Pages', href: '/admin/content-pages', permission: 'manage_content_pages' },
            { title: 'Media Library', href: '/admin/media-folders', permission: 'manage_media' },
            { title: 'Content Clusters', href: '/admin/blog-content-clusters', permission: 'manage_content_clusters' },
            { title: 'Content Gaps', href: '/admin/blog-content-gaps', permission: 'manage_content_gaps' },
            { title: 'Link Suggestions', href: '/admin/blog-internal-link-suggestions', permission: 'manage_link_suggestions' },
            { title: 'Entity Mentions', href: '/admin/blog-entity-mentions', permission: 'manage_entity_mentions' },
            { title: 'Authors', href: '/admin/authors', permission: 'manage_authors' },
            { title: 'Newsletter', href: '/admin/newsletter', permission: 'manage_newsletter' }
        ]
    },

    {
        title: 'SEO Suite',
        href: '#',
        icon: Search,
        permission: 'manage_seo',
        submenu: [
            { title: 'SEO Dashboard', href: '/admin/seo-dashboard', permission: 'view_seo_dashboard' },
            { title: 'Metadata', href: '/admin/seo-metas', permission: 'manage_seo_meta' },
            { title: 'Schema Markup', href: '/admin/schema-markups', permission: 'manage_schema_markup' },
            { title: 'Sitemaps', href: '/admin/sitemap-dashboard', permission: 'manage_sitemaps' },
            { title: 'Search Console', href: '/admin/search-console', permission: 'manage_seo_audits' },
            { title: 'Audits', href: '/admin/seo-audits', permission: 'manage_seo_audits' },
            { title: 'Competitor Analysis', href: '/admin/competitor-analyses', permission: 'manage_seo_audits' },
            { title: 'Keyword Research', href: '/admin/keyword-research', permission: 'manage_keyword_research' },
            { title: 'Local SEO', href: '/admin/local-seo-dashboard', permission: 'manage_local_seo' },
            { title: 'GMB Accounts', href: '/admin/google-my-business-accounts', permission: 'manage_gmb_accounts' },
            { title: 'Topical Authority', href: '/admin/topical-authority-dashboard', permission: 'view_topical_authority' },
            { title: 'Entity Framework', href: '/admin/central-entities', permission: 'manage_entities' },
        ]
    },

    {
        title: 'Analytics',
        href: '#',
        icon: BarChart2,
        permission: 'view_dashboard',
        submenu: [
            { title: 'Overview', href: '/admin/analytics-dashboard', permission: 'view_analytics' },
            { title: 'Advanced Analytics', href: '/admin/advanced-analytics', permission: 'view_advanced_analytics' },
        ]
    },

    {
        title: 'AI & Automation',
        href: '#',
        icon: Bot,
        permission: 'use_ai_tools',
        submenu: [
            { title: 'Chat Dashboard', href: '/admin/ai-chat-dashboard', permission: 'view_ai_chats' },
            { title: 'Chat Sessions', href: '/admin/chat-sessions', permission: 'manage_chat_sessions' },
            { title: 'Data Scraping', href: '/admin/data-scraping', permission: 'manage_data_scraping' },
            { title: 'Training Data', href: '/admin/ai-training-data', permission: 'manage_training_data' },
            { title: 'AI Settings', href: '/admin/ai-settings', permission: 'manage_ai_settings' },
        ]
    },

    {
        title: 'System Settings',
        href: '#',
        icon: Settings,
        permission: 'manage_settings',
        submenu: [
            { title: 'General', href: '/admin/site-settings', permission: 'manage_site_settings' },
            { title: 'Languages', href: '/admin/languages', permission: 'manage_languages' },
            { title: 'Themes', href: '/admin/themes', permission: 'manage_themes' },
            { title: 'Menus', href: '/admin/menus', permission: 'manage_menus' },
            { title: 'Cookie Policies', href: '/admin/cookie-policies', permission: 'manage_cookies' },
            { title: 'API Credentials', href: '/admin/api-credentials', permission: 'manage_api_keys' },
            { title: 'System Updates', href: '/admin/system-updates', permission: 'manage_updates' },
            { title: 'Maintenance', href: '/admin/system-maintenance', permission: 'manage_maintenance' },
            { title: 'Admins', href: '/admin/admins', permission: 'manage_users' },
            { title: 'Roles', href: '/admin/roles', permission: 'manage_roles' },
            { title: 'Contact Offices', href: '/admin/contact-offices', permission: 'manage_offices' },
            { title: 'Email Templates', href: '/admin/email-templates', permission: 'manage_email_templates' },
            { title: 'Email Settings', href: '/admin/email-settings', permission: 'manage_email_settings' },
            { title: 'Cloud Storage', href: '/admin/storage-settings', permission: 'manage_settings' },
            { title: 'Notification Log', href: '/admin/notification-log', permission: 'view_logs' },
            { title: 'License', href: '/admin/license-management', permission: 'manage_license' }
        ]
    }
];

export const PERMISSIONS: { id: string; label: string; group: string }[] = (() => {
    const perms: { id: string; label: string; group: string }[] = [];

    // General broad permissions
    const globalPerms = [
      { id: 'write', label: 'Global Write Access (Create/Update/Delete)', group: 'General' },
      { id: 'view_dashboard', label: 'Access Dashboard', group: 'General' },
      { id: 'use_ai_tools', label: 'Use AI Assistance', group: 'General' },
      { id: 'manage_system', label: 'Full System Access', group: 'General' },
      { id: 'manage_license', label: 'Manage System License', group: 'General' }
    ];
    globalPerms.forEach(p => perms.push(p));

    NAV_ITEMS.forEach(item => {
        // If it's a top-level group with a broad permission
        if (item.permission && !perms.some(p => p.id === item.permission)) {
            perms.push({
                id: item.permission,
                label: `Full Access: ${item.title}`,
                group: item.title
            });
        }
        
        // Granular sub-items
        if (item.submenu) {
            item.submenu.forEach(sub => {
                if (sub.permission && !perms.some(p => p.id === sub.permission)) {
                    perms.push({
                        id: sub.permission,
                        label: sub.title,
                        group: item.title
                    });
                }
            });
        }
    });

    return perms;
})();

export const MOCK_TOURS: Tour[] = [
    {
        id: 'tour-1',
        title: 'Serengeti Migration Safari',
        slug: 'serengeti-migration-safari',
        status: 'Published',
        price: 3500,
        duration: '7 Days',
        type: 'Wildlife',
        rating: 4.8,
        bookings: 124,
        featuredImage: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=800&q=80',
        description: 'Witness the Great Migration in the heart of the Serengeti.',
        overview: 'An unforgettable journey through the plains of the Serengeti.',
        itinerary: [],
        highlights: ['Great Migration', 'Big 5', 'Luxury Camping'],
        whySpecial: ['Witness the Great Migration up close', 'Expert-led photography sessions', 'Private bush dinners under the stars'],
        wildlifeEncounter: ['Lion', 'Leopard', 'Elephant', 'Buffalo', 'Rhino', 'Cheetah', 'Zebra', 'Wildebeest'],
        bestTimeToVisit: ['June', 'July', 'August', 'September', 'October'],
        included: ['Accommodation', 'Meals', 'Transport'],
        excluded: ['Flights', 'Tips'],
        startLocation: { name: 'Arusha', lat: -3.3731, lng: 36.6948, type: 'Start' },
        endLocation: { name: 'Arusha', lat: -3.3731, lng: 36.6948, type: 'End' },
        isFeatured: true,
        isPopular: true,
        clothingAccessories: ['Lightweight khaki shirts', 'Wide-brimmed sun hat', 'Comfortable walking shoes', 'Morning jacket'],
        photographyGear: ['DSLR with telephoto lens', 'Extra memory cards', 'Universal adapter', 'Binoculars'],
        personalItems: ['SPF 30+ Sunscreen', 'Insect repellent', 'Personal first aid kit', 'Wet wipes'],
        optionalItems: ['Travel journal', 'Flashlight', 'Travel pillow', 'E-reader/Kindle']
    },
    {
        id: 'tour-2',
        title: 'Kilimanjaro Machame Route',
        slug: 'kilimanjaro-machame-route',
        status: 'Published',
        price: 2800,
        duration: '6 Days',
        type: 'Hiking',
        rating: 4.9,
        bookings: 85,
        featuredImage: 'https://images.unsplash.com/photo-1650634629633-8a9d380966f3?auto=format&fit=crop&w=800&q=80',
        description: 'Conquer the roof of Africa on the scenic Machame route.',
        overview: 'A challenging yet rewarding trek to the summit of Kilimanjaro.',
        itinerary: [],
        whySpecial: ['The most scenic route to the summit', 'Excellent acclimatization profile', 'Stunning views of the Barranco Wall'],
        bestTimeToVisit: ['January', 'February', 'August', 'September'],
        startLocation: { name: 'Moshi', lat: -3.3349, lng: 37.3404, type: 'Start' },
        endLocation: { name: 'Moshi', lat: -3.3349, lng: 37.3404, type: 'End' },
        isFeatured: false,
        isPopular: true,
        clothingAccessories: ['Thermal base layers', 'Waterproof hiking boots', 'Gore-Tex jacket', 'Polarized sunglasses'],
        photographyGear: ['GoPro Hero 11', 'Power bank (20000mAh)', 'Peak Design clip', 'Lens cleaning kit'],
        personalItems: ['Lip balm with SPF', 'Blister plasters', 'Electrolyte tablets', 'Biodegradable soap'],
        optionalItems: ['Lightweight camp shoes', 'Buff/Neck gaiter', 'Thermal gloves', 'Summit flag']
    },
    {
        id: 'tour-3',
        title: 'Zanzibar Beach & Spice',
        slug: 'zanzibar-beach-spice',
        status: 'Published',
        price: 1200,
        duration: '4 Days',
        type: 'Cultural',
        rating: 4.7,
        bookings: 65,
        featuredImage: 'https://images.unsplash.com/photo-1544976773-138374d68249?auto=format&fit=crop&w=800&q=80',
        description: 'Relax on pristine beaches and explore the historic Stone Town.',
        overview: 'A perfect blend of cultural exploration in Stone Town and relaxation on the white sandy beaches of Nungwi. Visit spice farms, historic sites, and enjoy sunset dhow cruises.',
        itinerary: [
            { day: 1, title: 'Arrival in Stone Town', description: 'Arrive at Zanzibar International Airport (ZNZ) and transfer to your hotel in historic Stone Town. Evening sunset Dhow cruise.', accommodation: 'Tembo House Hotel' },
            { day: 2, title: 'Spice Farm & Stone Town Tour', description: 'Morning guided tour of a local spice farm. Afternoon walking tour through the narrow alleys of Stone Town, visiting the Old Fort and House of Wonders.', accommodation: 'Tembo House Hotel', meals: ['Breakfast', 'Lunch'] },
            { day: 3, title: 'Transfer to Nungwi Beach', description: 'Travel north to Nungwi. Spend the day relaxing on the beach or swimming in the turquoise waters.', accommodation: 'Z Hotel', meals: ['Breakfast'] },
            { day: 4, title: 'Departure', description: 'Morning at leisure before transfer to airport.', accommodation: '', meals: ['Breakfast'] }
        ],
        highlights: ['Stone Town UNESCO Site', 'Spice Farm Tour', 'Nungwi Beaches', 'Sunset Dhow Cruise'],
        whySpecial: ['Authentic cultural immersion in Stone Town', 'Pristine white sandy beaches of Nungwi', 'Unique spice farm sensory experience'],
        wildlifeEncounter: ['Flamingo', 'Dolphins'],
        bestTimeToVisit: ['June', 'July', 'August', 'September', 'October', 'December', 'January', 'February'],
        included: ['Airport Transfers', 'Accommodation', 'Breakfasts', 'Guided Tours'],
        excluded: ['International Flights', 'Lunches & Dinners', 'Drinks'],
        startLocation: { name: 'Zanzibar City', lat: -6.1659, lng: 39.2026, type: 'Start' },
        endLocation: { name: 'Zanzibar City', lat: -6.1659, lng: 39.2026, type: 'End' },
        isFeatured: true,
        isPopular: false
    }
];

export const MOCK_DESTINATIONS: Destination[] = [
    {
        id: 'dest-1',
        name: 'Serengeti National Park',
        slug: 'serengeti-national-park',
        country: 'Tanzania',
        description: 'Endless plains teeming with wildlife.',
        image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=800&q=80',
        toursCount: 15,
        status: 'Active',
        rating: 5.0,
        coordinates: { lat: -2.3333, lng: 34.8333 }
    },
    {
        id: 'dest-2',
        name: 'Ngorongoro Crater',
        slug: 'ngorongoro-crater',
        country: 'Tanzania',
        description: 'The world\'s largest inactive volcanic caldera.',
        image: 'https://images.unsplash.com/photo-1547471080-75281e02c54e?auto=format&fit=crop&w=800&q=80',
        toursCount: 10,
        status: 'Active',
        rating: 4.9,
        coordinates: { lat: -3.2444, lng: 35.5667 }
    }
];

export const MOCK_THEME_SECTIONS: ThemeSection[] = [
    {
        id: "mock-hero",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'hero',
        isVisible: true,
        order: 0,
        styles: {
            alignment: 'center',
            paddingTop: 0,
            paddingBottom: 0,
            containerWidth: 'full',
            background: { type: 'image', url: '/assets/images/tours/tanzania-safaris.avif', opacity: 40 }
        },
        content: {
            subtitle: 'Premium Safari Experiences',
            heading: 'Wild Heart of Africa',
            description: 'Curated Tanzania safaris designed for the modern explorer.',
            subtitleStyle: { fontFamily: 'Space Grotesk', fontSize: 12, fontWeight: 700, lineHeight: 1.2, letterSpacing: 0, textTransform: 'none', color: '#FFFFFF' },
            headingStyle: { fontFamily: 'Space Grotesk', fontSize: 72, fontWeight: 700, lineHeight: 1.2, letterSpacing: 0, textTransform: 'none', color: '#FFFFFF' },
            descriptionStyle: { fontFamily: 'Inter', fontSize: 18, fontWeight: 700, lineHeight: 1.2, letterSpacing: 0, textTransform: 'none', color: '#FFFFFF' },
            buttons: [{ id: 'b1', label: 'Explore Tours', url: '/tours', target: '_self', style: 'primary' }],
            contentOrder: ['subtitle', 'heading', 'description', 'buttons', 'search', 'trust'],
            searchLayout: 'horizontal',
            trustIcons: [{ icon: 'ShieldCheck', text: 'Certified Guides' }, { icon: 'Star', text: 'Top Rated' }]
        }
    },
    {
        id: "mock-tours",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'featured_tours',
        isVisible: true,
        order: 1,
        styles: {
            alignment: 'center',
            paddingTop: 80,
            paddingBottom: 80,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#ffffff', opacity: 100 }
        },
        content: {
            heading: 'Iconic Expeditions',
            subtitle: 'Curated Journeys',
            itemsLimit: 3,
            headingStyle: { fontFamily: 'Space Grotesk', fontSize: 48, fontWeight: 700, lineHeight: 1.2, letterSpacing: 0, textTransform: 'none', color: '#000000' },
            subtitleStyle: { fontFamily: 'Space Grotesk', fontSize: 12, fontWeight: 700, lineHeight: 1.2, letterSpacing: 0, textTransform: 'none', color: '#FF5722' }
        }
    },
    {
        id: "mock-about",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'about',
        isVisible: true,
        order: 2,
        styles: {
            alignment: 'left',
            paddingTop: 80,
            paddingBottom: 80,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#f8fafc', opacity: 100 }
        },
        content: {
            heading: 'Our Story',
            subtitle: 'The Spirit of Safari',
            description: 'Born from a passion for the African wilderness, Esiringet Safaris crafts bespoke journeys that go beyond the ordinary.',
            image: '/assets/images/tours/Arusha-national-park-tanzania.avif'
        }
    },
    {
        id: "mock-destinations",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'destinations',
        isVisible: true,
        order: 3,
        styles: {
            alignment: 'center',
            paddingTop: 80,
            paddingBottom: 80,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#ffffff', opacity: 100 }
        },
        content: {
            heading: 'Top Parks & Regions',
            subtitle: 'Where to Go',
            cardStyle: 'overlay'
        }
    },
    {
        id: "mock-accommodations",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'accommodations',
        isVisible: true,
        order: 4,
        styles: {
            alignment: 'center',
            paddingTop: 80,
            paddingBottom: 80,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#2C2C2C', opacity: 100 }
        },
        content: {
            heading: 'Luxury in the Wild',
            subtitle: 'Handpicked Stays',
            description: 'From tented camps under the stars to luxury lodges on the crater rim.'
        }
    },
    {
        id: "mock-activities",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'activities',
        isVisible: true,
        order: 5,
        styles: {
            alignment: 'center',
            paddingTop: 80,
            paddingBottom: 80,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#ffffff', opacity: 100 }
        },
        content: {
            heading: 'Beyond the Drive',
            subtitle: 'Curated Experiences',
            description: 'Hot air ballooning, walking safaris, and cultural immersions.'
        }
    },
    {
        id: "mock-blog",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'blog',
        isVisible: true,
        order: 6,
        styles: {
            alignment: 'center',
            paddingTop: 80,
            paddingBottom: 80,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#f8fafc', opacity: 100 }
        },
        content: {
            heading: 'Safari Journal',
            subtitle: 'Tips & Inspiration',
            itemsLimit: 3
        }
    },
    {
        id: "mock-cta",
        themeId: 'serengeti-sunrise',
        page: 'home',
        type: 'cta',
        isVisible: true,
        order: 8,
        styles: {
            alignment: 'center',
            paddingTop: 100,
            paddingBottom: 100,
            containerWidth: 'boxed',
            background: { type: 'image', url: 'https://images.unsplash.com/photo-1547471080-75281e02c54e', opacity: 60 }
        },
        content: {
            heading: 'Ready to Start Your Adventure?',
            description: 'Book your lifetime trip today with our expert guides.',
            buttons: [{ id: 'cta1', label: 'Contact Us', url: '/contact', target: '_self', style: 'primary' }]
        }
    },
    // Zanzibar Blue Sections
    {
        id: "zb-hero",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'hero',
        isVisible: true,
        order: 0,
        styles: {
            alignment: 'left',
            paddingTop: 0,
            paddingBottom: 0,
            containerWidth: 'full',
            background: { type: 'image', url: '/assets/images/tours/tanzania-safaris.avif', opacity: 30 }
        },
        content: {
            subtitle: "Africa's #1 Budget Safari Operator",
            heading: "Discover Africa's Wild Beauty",
            description: "Experience unforgettable safari adventures across 12 African countries without breaking the bank.",
            buttons: [
                { id: 'b1', label: 'Explore Safari Tours', url: '/tours', target: '_self', style: 'primary' },
                { id: 'b2', label: 'Plan Custom Safari', url: '/contact', target: '_self', style: 'secondary' }
            ]
        }
    },
    {
        id: "zb-tours",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'featured_tours',
        isVisible: true,
        order: 1,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Featured Safari Tours',
            description: "Handpicked adventures that offer the best value for money across Africa's most spectacular destinations"
        }
    },
    {
        id: "zb-about",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'about',
        isVisible: true,
        order: 2,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Why Choose GoAfrica Budget Safaris?',
            description: "For over 15 years, we've been making African safari dreams accessible to travelers from around the world."
        }
    },
    {
        id: "zb-accommodations",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'accommodations',
        isVisible: true,
        order: 3,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Comfortable Safari Accommodations',
            description: "Rest easy in carefully selected lodges and camps that balance comfort, authenticity, and affordability"
        }
    },
    {
        id: "zb-activities",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'activities',
        isVisible: true,
        order: 4,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Unforgettable Safari Activities',
            description: "Experience Africa's wilderness through diverse activities designed for adventure seekers and nature lovers"
        }
    },
    {
        id: "zb-blog",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'blog',
        isVisible: true,
        order: 5,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Latest from Our Travel Blog',
            description: "Discover insider tips, wildlife insights, and inspiring stories from our African safari adventures"
        }
    },
    {
        id: "zb-destinations",
        themeId: 'zanzibar-blue',
        page: 'home',
        type: 'countries',
        isVisible: true,
        order: 6,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Explore Our Destinations',
            description: "From the plains of the Serengeti to the beaches of Zanzibar."
        }
    },
    // African Vacation Sections
    {
        id: "av-hero",
        themeId: 'african-vacation',
        page: 'home',
        type: 'hero',
        isVisible: true,
        order: 0,
        styles: {
            alignment: 'left',
            paddingTop: 0,
            paddingBottom: 0,
            containerWidth: 'full',
            background: { type: 'image', url: '/assets/images/tours/tanzania-safaris.avif', opacity: 60 }
        },
        content: {
            subtitle: "Discover Tanzania's Wonders",
            heading: "Discover Tanzania's Wild Beauty",
            description: "Experience unforgettable safaris, pristine beaches, and authentic African adventures",
            buttons: [
                { id: 'av-b1', label: 'Start Planning Now', url: '/contact', target: '_self', style: 'primary' },
                { id: 'av-b2', label: 'Explore Our Safaris', url: '/tours', target: '_self', style: 'outline' }
            ],
            trustIcons: [
                { icon: 'star', text: '4.9/5 Rating' },
                { icon: 'users', text: '10,000+ Happy Travelers' },
                { icon: 'shield', text: 'Licensed & Insured' }
            ]
        }
    },
    {
        id: "av-tours",
        themeId: 'african-vacation',
        page: 'home',
        type: 'featured_tours',
        isVisible: true,
        order: 1,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Popular Safari Packages',
            description: "Handpicked adventures for unforgettable experiences"
        }
    },
    {
        id: "av-activities",
        themeId: 'african-vacation',
        page: 'home',
        type: 'activities',
        isVisible: true,
        order: 2,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Explore Activities',
            description: "From wildlife encounters to cultural immersions"
        }
    },
    {
        id: "av-accommodations",
        themeId: 'african-vacation',
        page: 'home',
        type: 'accommodations',
        isVisible: true,
        order: 3,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Luxury Accommodations',
            description: "Stay in style across Tanzania's most beautiful locations"
        }
    },
    {
        id: "av-destinations",
        themeId: 'african-vacation',
        page: 'home',
        type: 'countries',
        isVisible: true,
        order: 4,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Top Destinations',
            description: "Discover Tanzania's most iconic locations"
        }
    },
    {
        id: "av-blog",
        themeId: 'african-vacation',
        page: 'home',
        type: 'blog',
        isVisible: true,
        order: 5,
        styles: { alignment: 'center', paddingTop: 80, paddingBottom: 80, containerWidth: 'boxed' },
        content: {
            heading: 'Travel Insights & Stories',
            description: "Expert tips and inspiration for your African adventure"
        }
    },
    {
        id: "av-cta",
        themeId: 'african-vacation',
        page: 'home',
        type: 'cta',
        isVisible: true,
        order: 6,
        styles: {
            alignment: 'center',
            paddingTop: 100,
            paddingBottom: 100,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#f97316', opacity: 100 }
        },
        content: {
            heading: 'Ready for Your African Adventure?',
            description: "Join thousands of happy travelers who trusted us with their dream vacation",
            buttons: [
                { id: 'av-cta-b1', label: 'Start Planning Now', url: '/contact', target: '_self', style: 'primary' },
                { id: 'av-cta-b2', label: 'Chat on WhatsApp', url: '#', target: '_blank', style: 'secondary' }
            ]
        }
    },
    // Rough and Dusty Sections
    {
        id: "rd-hero",
        themeId: 'rough-and-dusty',
        page: 'home',
        type: 'hero',
        isVisible: true,
        order: 0,
        styles: {
            alignment: 'left',
            paddingTop: 0,
            paddingBottom: 0,
            containerWidth: 'full',
            background: { type: 'image', url: '/assets/images/tours/tanzania-safaris.avif', opacity: 100 }
        },
        content: {
            heading: "EMBRACE THE",
            highlightText: "UNTAMED WILD",
            description: "Experience the raw majesty of the African savannah with our expert-led luxury expeditions."
        }
    },
    {
        id: "rd-tours",
        themeId: 'rough-and-dusty',
        page: 'home',
        type: 'featured_tours',
        isVisible: true,
        order: 1,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: "FEATURED EXPEDITIONS",
            description: "Hand-picked safari adventures designed for the curious and the brave."
        }
    },
    {
        id: "rd-about",
        themeId: 'rough-and-dusty',
        page: 'home',
        type: 'about',
        isVisible: true,
        order: 2,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: "WHY CHOOSE OUR WILDERNESS EXPEDITIONS",
            description: "Since 2005, we've been the primary choice for travelers seeking more than just a vacation.",
            image: '/assets/images/tours/Arusha-national-park-tanzania.avif'
        }
    },
    {
        id: "rd-cta",
        themeId: 'rough-and-dusty',
        page: 'home',
        type: 'cta',
        isVisible: true,
        order: 3,
        styles: {
            alignment: 'center',
            paddingTop: 100,
            paddingBottom: 100,
            containerWidth: 'boxed',
            background: { type: 'color', color: '#4A5A2A', opacity: 100 }
        },
        content: {
            heading: "READY FOR YOUR NEXT",
            highlightText: "WILDERNESS JOURNEY?",
            description: "Our expedition experts are standing by to help you craft the perfect African safari."
        }
    },
    // Mikumi Safaris Sections
    {
        id: "ms-hero",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'hero',
        isVisible: true,
        order: 0,
        styles: {
            alignment: 'center',
            paddingTop: 0,
            paddingBottom: 0,
            containerWidth: 'full',
            background: { type: 'video', url: 'https://vimeo.com/712345678', opacity: 40 }
        },
        content: {
            subtitle: "Luxury Safari Expeditions",
            heading: "Experience the Essence of Tanzania",
            description: "Bespoke, high-luxury wildlife journeys tailored for the discerning traveler.",
            buttons: [
                { id: 'ms-b1', label: 'View Our Safaris', url: '/tours', target: '_self', style: 'primary' },
                { id: 'ms-b2', label: 'Plan Your Trip', url: '/contact', target: '_self', style: 'outline' }
            ]
        }
    },
    {
        id: "ms-tours",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'featured_tours',
        isVisible: true,
        order: 1,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: 'Curated Expeditions',
            description: "Elite safari packages featuring Tanzania's most iconic wildlife destinations."
        }
    },
    {
        id: "ms-destinations",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'destinations',
        isVisible: true,
        order: 2,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: 'Iconic Destinations',
            description: "From the depths of Ngorongoro to the endless plains of Serengeti."
        }
    },
    {
        id: "ms-about",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'about',
        isVisible: true,
        order: 3,
        styles: { alignment: 'left', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: 'The Mikumi Standard',
            description: "Crafting exceptional safari experiences with a commitment to luxury, safety, and conservation.",
            image: 'https://images.unsplash.com/photo-1547471080-75281e02c54e?auto=format&fit=crop&w=800&q=80'
        }
    },
    {
        id: "ms-activities",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'activities',
        isVisible: true,
        order: 4,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: 'Bespoke Activities',
            description: "Beyond the game drive - immersive cultural and adventure experiences."
        }
    },
    {
        id: "ms-accommodations",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'accommodations',
        isVisible: true,
        order: 5,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: 'Exquisite Stays',
            description: "Ultra-luxury lodges and tented camps in the heart of the wild."
        }
    },
    {
        id: "ms-blog",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'blog',
        isVisible: true,
        order: 6,
        styles: { alignment: 'center', paddingTop: 100, paddingBottom: 100, containerWidth: 'boxed' },
        content: {
            heading: 'Safari Chronicles',
            description: "Insights, guides, and stories from the African wilderness."
        }
    },
    {
        id: "ms-cta",
        themeId: 'mikumi-safaris',
        page: 'home',
        type: 'cta',
        isVisible: true,
        order: 7,
        styles: {
            alignment: 'center',
            paddingTop: 120,
            paddingBottom: 120,
            containerWidth: 'boxed',
            background: { type: 'image', url: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=1200' }
        },
        content: {
            heading: "Begin Your Elite Journey",
            description: "Speak with our safari architects today to design your bespoke expedition.",
            buttons: [
                { id: 'ms-cta-b1', label: 'Start Planning', url: '/contact', target: '_self', style: 'primary' }
            ]
        }
    }
];

export const MOCK_THEMES: Theme[] = [
    {
        id: 'serengeti-sunrise',
        name: 'Serengeti Sunrise',
        slug: 'serengeti-sunrise',
        version: '2.5.0',
        author: 'Esiringet',
        thumbnail: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=400&q=80',
        isActive: true,
        status: 'Active',
        createdAt: '2023-01-01',
        updatedAt: '2024-03-20',
        description: 'Cinematic earth-toned theme with dynamic section controls.',
        settings: {
            primaryColor: '#FF5722',
            secondaryColor: '#1A1A1A',
            accentColor: '#FFC107',
            backgroundColor: '#FFFFFF',
            textColor: '#333333',
            headingFont: 'Space Grotesk',
            bodyFont: 'Inter',
            borderRadius: 24,
            containerWidth: '1280px',
            headerMode: 'sticky',
            showTopbar: true,
            topbarPhone: '+255 123 456 789',
            topbarEmail: 'info@esiringet.com',
            showLanguageSwitcher: true,
            showCurrencySwitcher: true,
            showCtaInHeader: true,
            sections: [],
            footerBackground: { type: 'color', color: '#0f172a', opacity: 100 },
            footerColumns: [],
            copyrightText: '© 2024 Serengeti Sunrise'
        }
    },
    {
        id: 'african-vacation',
        name: 'African Vacation',
        slug: 'african-vacation',
        version: '1.0.0',
        author: 'Esiringet',
        thumbnail: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=400&q=80',
        isActive: false,
        status: 'Installed',
        createdAt: '2024-01-07',
        updatedAt: '2024-01-07',
        description: 'Premium modern safari theme with video hero and vibrant orange accents.',
        settings: {
            primaryColor: '#f97316',
            secondaryColor: '#ea580c',
            accentColor: '#ffedd5',
            backgroundColor: '#F9FAFB',
            textColor: '#1F2937',
            headingFont: 'Poppins',
            bodyFont: 'Poppins',
            borderRadius: 16,
            containerWidth: '1280px',
            headerMode: 'transparent',
            showTopbar: false,
            topbarPhone: '+255 123 456 789',
            topbarEmail: 'info@africanvacation.com',
            showLanguageSwitcher: true,
            showCurrencySwitcher: true,
            showCtaInHeader: true,
            sections: [],
            footerBackground: { type: 'color', color: '#111827', opacity: 100 },
            footerColumns: [],
            copyrightText: '© 2025 African Vacation'
        }
    },
    {
        id: 'zanzibar-blue',
        name: 'Zanzibar Blue',
        slug: 'zanzibar-blue',
        version: '1.1.0',
        author: 'Esiringet',
        thumbnail: 'https://images.unsplash.com/photo-1537833555134-f7ddf7c2d8fe?auto=format&fit=crop&w=400&q=80',
        isActive: false,
        status: 'Installed',
        createdAt: '2023-05-10',
        updatedAt: '2024-03-25',
        description: 'A clean, modern professional theme with deep ocean blues and crisp white layouts.',
        settings: {
            primaryColor: '#0077b6',
            secondaryColor: '#023e8a',
            accentColor: '#caf0f8',
            backgroundColor: '#ffffff',
            textColor: '#03045e',
            headingFont: 'Plus Jakarta Sans',
            bodyFont: 'Plus Jakarta Sans',
            borderRadius: 12,
            containerWidth: '1200px',
            headerMode: 'sticky',
            showTopbar: true,
            topbarPhone: '+255 123 456 789',
            topbarEmail: 'info@zanzibar-expeditions.com',
            showLanguageSwitcher: true,
            showCurrencySwitcher: true,
            showCtaInHeader: true,
            sections: [],
            footerBackground: { type: 'color', color: '#03045e', opacity: 100 },
            footerColumns: [],
            copyrightText: '© 2024 Zanzibar Blue Expedition. All rights reserved.'
        }
    },
    {
        id: 'rough-and-dusty',
        name: 'RoughandDusty',
        slug: 'rough-and-dusty',
        version: '1.0.0',
        author: 'Esiringet',
        thumbnail: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=400&q=80',
        isActive: false,
        status: 'Installed',
        createdAt: '2024-01-08',
        updatedAt: '2024-01-08',
        description: 'Adventurous, rugged theme with earth tones and broad typography.',
        settings: {
            primaryColor: '#6B7B3A',
            secondaryColor: '#4A5A2A',
            accentColor: '#D4A574',
            backgroundColor: '#F8F6F3',
            textColor: '#2C2C2C',
            headingFont: 'Oswald',
            bodyFont: 'Open Sans',
            accentFont: 'Roboto Condensed',
            borderRadius: 8,
            containerWidth: '1180px',
            headerMode: 'sticky',
            showTopbar: true,
            topbarPhone: '+255 744 555 666',
            topbarEmail: 'adventure@roughanddusty.com',
            showLanguageSwitcher: true,
            showCurrencySwitcher: true,
            showCtaInHeader: true,
            sections: [],
            footerBackground: { type: 'color', color: '#2C2C2C', opacity: 100 },
            footerColumns: [],
            copyrightText: '© 2025 Rough and Dusty Safaris'
        }
    },
    {
        id: 'mikumi-safaris',
        name: 'Mikumi Safaris',
        slug: 'mikumi-safaris',
        version: '1.0.0',
        author: 'Esiringet',
        thumbnail: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=400&q=80',
        isActive: false,
        status: 'Installed',
        createdAt: '2026-01-29',
        updatedAt: '2026-01-29',
        description: 'Elite, high-luxury safari theme with deep blues and focused performance.',
        settings: {
            primaryColor: '#2563eb',
            secondaryColor: '#1d4ed8',
            accentColor: '#3b82f6',
            backgroundColor: '#ffffff',
            textColor: '#111827',
            headingFont: 'Poppins',
            bodyFont: 'Inter',
            borderRadius: 32,
            containerWidth: '1280px',
            headerMode: 'sticky',
            showTopbar: true,
            topbarPhone: '+255 123 456 789',
            topbarEmail: 'info@mikumisafaris.com',
            showLanguageSwitcher: true,
            showCurrencySwitcher: true,
            showCtaInHeader: true,
            sections: [],
            footerBackground: { type: 'color', color: '#111827', opacity: 100 },
            footerColumns: [],
            copyrightText: '© 2026 Mikumi Safaris'
        }
    }
];

export const MOCK_REVIEWS: Review[] = [
    { id: '1', author: 'John Doe', rating: 5, date: '2024-01-10', source: 'TripAdvisor', content: 'Amazing experience! The Great Migration was breath-taking.', status: 'Published', avatar: 'https://i.pravatar.cc/150?u=john' }
];

export const MOCK_COUNTRIES: Country[] = [
    { id: '1', name: 'Tanzania', code: 'TZ', region: 'East Africa', toursCount: 24, destinationsCount: 8, status: 'Active', image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=800&q=80' }
];

export const MOCK_BLOG_POSTS: BlogPost[] = [
    { id: '1', title: 'Great Migration Guide', slug: 'migration-guide', content: '<p>The Great Migration...</p>', excerpt: 'A guide to migration...', author: 'Admin', category: 'Wildlife', tags: [], status: 'Published', publishedDate: '2024-01-01', views: 120, image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=800&q=80' }
];

export const MOCK_MENUS: Menu[] = [
    { id: '1', name: 'Main Menu', location: 'main_menu', items: [{ id: '1', label: 'Home', type: 'page', url: '/', target: '_self' }, { id: '2', label: 'Tours', type: 'page', url: '/tours', target: '_self' }, { id: '3', label: 'Contact', type: 'page', url: '/contact', target: '_self' }], cta: { enabled: true, label: 'Book Now', url: '/tours', target: '_self' } }
];

export const MOCK_MAINTENANCE_TASKS: MaintenanceTask[] = [
    { id: '1', taskName: 'Database Backup', lastRun: '2024-01-20 02:00 AM', status: 'Healthy', frequency: 'Daily' }
];

export const MOCK_SYSTEM_LOGS: SystemLog[] = [
    { id: '1', level: 'Info', message: 'System started.', source: 'System', timestamp: '2024-01-20T10:00:00Z' }
];

export const MOCK_SITE_SETTINGS: Partial<SiteSettings>[] = [
    { siteName: 'Serengeti Sunrise Safaris', tagline: 'Experience the wild beauty of Africa', logoUrl: '', faviconUrl: '', siteUrl: 'http://localhost:5173' }
];

export const MOCK_CUSTOMERS: Customer[] = [
    {
        id: 'cust-001',
        firstName: 'Alice',
        lastName: 'Freeman',
        email: 'alice@example.com',
        phone: '+1 555 123 4567',
        country: 'USA',
        status: 'Active',
        loyaltyTier: 'Gold',
        totalBookings: 3,
        totalSpent: 12500,
        lastBookingDate: '2023-11-15',
        tags: ['VIP', 'Repeat'],
        avatar: 'https://i.pravatar.cc/150?u=alice'
    }
];

export const MOCK_BOOKINGS: Booking[] = [
    {
        id: 'bk-001',
        reference: 'BK-2023-001',
        customerName: 'Alice Freeman',
        customerEmail: 'alice@example.com',
        tourTitle: 'Serengeti Migration Safari',
        bookingDate: '2023-10-01',
        departureDate: '2024-02-10',
        status: 'Confirmed',
        paymentStatus: 'Paid',
        adults: 2,
        children: 0,
        infants: 0,
        total_amount: 7000
    }
];

export const MOCK_TOUR_DEPARTURES: TourDeparture[] = [
    {
        id: 'dep-001',
        tourId: 'tour-1',
        tourTitle: 'Serengeti Migration Safari',
        startDate: '2024-06-15',
        endDate: '2024-06-22',
        price: 3500,
        availableSeats: 4,
        totalSeats: 12,
        status: 'Open'
    }
];

export const MOCK_API_KEYS: PartnerApiKey[] = [];

export const MOCK_CURRENCIES: Currency[] = [
    { code: 'USD', name: 'US Dollar', symbol: '$', rate: 1, isBase: true, status: 'Active', lastUpdated: new Date().toISOString() }
];

export const MOCK_LANGUAGES: Language[] = [
    { code: 'en', name: 'English', nativeName: 'English', script: 'Latin', direction: 'ltr', isActive: true, isDefault: true, flagCode: 'us' }
];

export const MOCK_ENTITIES: CentralEntity[] = [
    { id: 'ENT-01', name: 'African Safari', type: 'Topic', slug: 'african-safari', authorityScore: 85, contentCoverage: 92, status: 'Optimized', lastUpdated: '2023-11-15' },
    { id: 'ENT-02', name: 'Serengeti National Park', type: 'Location', slug: 'serengeti', authorityScore: 90, contentCoverage: 88, status: 'Optimized', lastUpdated: '2023-11-10' }
];

export const MOCK_CONTACT_OFFICES: ContactOffice[] = [
    {
        id: 'office-1',
        name: 'Arusha HQ',
        type: 'Headquarters',
        address: '123 Serengeti Road',
        city: 'Arusha',
        country: 'Tanzania',
        email: 'info@example.com',
        phone: '+255 123 456 789',
        coordinates: { lat: -3.3731, lng: 36.6948 },
        status: 'Active',
        staffIds: ['admin-1']
    }
];

export const MOCK_ACTIVITIES: Activity[] = [
    {
        id: 'act-001',
        name: 'Hot Air Balloon Safari',
        slug: 'balloon-safari',
        description: 'Float over the Serengeti plains at sunrise.',
        duration: '4 Hours',
        difficulty: 'Easy',
        price: 550,
        location: 'Serengeti',
        coordinates: { lat: -2.3333, lng: 34.8333 },
        category: 'Aerial',
        image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=800&q=80',
        status: 'Active'
    },
    {
        id: 'ACT-002',
        name: 'Walking Safari',
        slug: 'walking-safari',
        description: 'Experience the bush on foot with an armed ranger guide. Get close to nature in a way that vehicle safaris cannot match.',
        duration: '3 Hours',
        difficulty: 'Moderate',
        price: 150,
        location: 'Tarangire',
        coordinates: { lat: -3.8333, lng: 36.0000 },
        category: 'Adventure',
        image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=800&q=80',
        status: 'Active'
    }
];

export const MOCK_ACCOMMODATIONS: Accommodation[] = [
    {
        id: 'acc-001',
        name: 'Serengeti Wilderness Camp',
        slug: 'serengeti-wilderness-camp',
        type: 'Camp',
        rating: 4.8,
        location: 'Serengeti Central',
        description: 'An authentic mobile camp experience.',
        address: 'Serengeti Central, Tanzania',
        coordinates: { lat: -2.3, lng: 34.8 },
        checkInTime: '2:00 PM',
        checkOutTime: '11:00 AM',
        priceRange: '$350 - $600',
        amenities: ['WiFi', 'Solar Power', 'Full Board'],
        mealPlans: ['Full Board'],
        image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?auto=format&fit=crop&w=800&q=80',
        roomsCount: 12,
        status: 'Active',
        rooms: []
    }
];

export const MOCK_REGIONAL_ENTITIES: RegionalEntity[] = [];

export const MOCK_CONTENT_PAGES: ContentPage[] = [
    {
        id: 'page-about',
        title: 'About Us',
        slug: 'about',
        status: 'Published',
        template: 'Default',
        author: 'Admin',
        lastModified: '2024-01-01',
        views: 1200,
        content: `<h2>Our Story</h2><p>Founded in 2010, we have been crafting unforgettable safaris...</p>`,
        seo: { title: 'About Us | Safari Adventures', description: 'Learn about our history and mission.', keywords: ['about', 'safari', 'team'] }
    },
    {
        id: 'page-contact',
        title: 'Contact Us',
        slug: 'contact',
        status: 'Published',
        template: 'Default',
        author: 'Admin',
        lastModified: '2024-01-01',
        views: 800,
        content: `<h2>Get in Touch</h2><p>We'd love to hear from you. Fill out the form below or call us.</p>`,
        seo: { title: 'Contact Us | Safari Adventures', description: 'Contact our safari experts today.', keywords: ['contact', 'email', 'phone'] }
    },
    {
        id: 'page-privacy',
        title: 'Privacy Policy',
        slug: 'privacy',
        status: 'Published',
        template: 'Default',
        author: 'Admin',
        lastModified: '2024-01-01',
        views: 300,
        content: `<h2>Privacy Policy</h2><p>Your privacy is important to us...</p>`,
        seo: { title: 'Privacy Policy', description: 'Our privacy commitments.', keywords: ['privacy', 'policy'] }
    }
];

export const MOCK_COOKIE_POLICIES: CookiePolicy[] = [];
export const MOCK_SCHEMA_MARKUPS: SchemaMarkup[] = [];
export const MOCK_SEO_METADATA: SeoMetaRecord[] = [];
export const MOCK_BLOG_TAGS: BlogTag[] = [];
export const MOCK_MEDIA_FOLDERS: MediaFolder[] = [];
export const MOCK_MEDIA_FILES: MediaFile[] = [];
export const MOCK_PAYMENTS: Payment[] = [];
export const MOCK_PAYMENT_GATEWAYS: PaymentGateway[] = [
    {
        id: 'pg-bank-transfer',
        name: 'Bank Transfer',
        slug: 'bank-transfer',
        logo: '/artifacts/bank_transfer_logo_1768420101542.png',
        status: 'Active',
        mode: 'Live',
        transactionFee: 0,
        fixedFee: 0,
        supportedCurrencies: ['USD', 'EUR', 'GBP', 'TZS', 'KES', 'UGX', 'ZAR'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })
    },
    {
        id: 'pg-pesapal',
        name: 'Pesapal',
        slug: 'pesapal',
        logo: '/artifacts/pesapal_logo_1768420118346.png',
        status: 'Inactive',
        mode: 'Test',
        transactionFee: 3.5,
        fixedFee: 0,
        supportedCurrencies: ['USD', 'KES', 'UGX', 'TZS', 'RWF', 'BIF'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }),
        apiKey: '',
        secretKey: ''
    },
    {
        id: 'pg-instasend',
        name: 'Instasend',
        slug: 'instasend',
        logo: '/artifacts/instasend_logo_1768420134507.png',
        status: 'Inactive',
        mode: 'Test',
        transactionFee: 2.5,
        fixedFee: 0,
        supportedCurrencies: ['KES', 'UGX', 'TZS'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }),
        apiKey: '',
        secretKey: ''
    },
    {
        id: 'pg-flutterwave',
        name: 'Flutterwave',
        slug: 'flutterwave',
        logo: '/artifacts/flutterwave_logo_1768420149583.png',
        status: 'Inactive',
        mode: 'Test',
        transactionFee: 3.8,
        fixedFee: 0.5,
        supportedCurrencies: ['USD', 'EUR', 'GBP', 'NGN', 'KES', 'UGX', 'TZS', 'ZAR', 'GHS', 'RWF'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }),
        apiKey: '',
        secretKey: ''
    },
    {
        id: 'pg-dpo',
        name: 'DPO',
        slug: 'dpo',
        logo: '/artifacts/dpo_logo_1768420166838.png',
        status: 'Inactive',
        mode: 'Test',
        transactionFee: 3.0,
        fixedFee: 0,
        supportedCurrencies: ['USD', 'EUR', 'GBP', 'ZAR', 'KES', 'TZS', 'UGX', 'MWK', 'ZMW'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }),
        apiKey: '',
        secretKey: ''
    },
    {
        id: 'pg-payfast',
        name: 'Payfast',
        slug: 'payfast',
        logo: '/artifacts/payfast_logo_1768420183242.png',
        status: 'Inactive',
        mode: 'Test',
        transactionFee: 3.9,
        fixedFee: 2.0,
        supportedCurrencies: ['ZAR'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }),
        apiKey: '',
        secretKey: ''
    },
    {
        id: 'pg-relworx',
        name: 'Relworx',
        slug: 'relworx',
        logo: 'https://via.placeholder.com/150/6B46C1/FFFFFF?text=Relworx',
        status: 'Inactive',
        mode: 'Test',
        transactionFee: 2.9,
        fixedFee: 0,
        supportedCurrencies: ['USD', 'EUR', 'GBP', 'KES', 'TZS', 'UGX'],
        lastSync: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }),
        apiKey: '',
        secretKey: ''
    }
];
export const MOCK_SEARCH_QUERIES: SearchQueryStat[] = [
    { query: 'safari in tanzania', impressions: 1200, clicks: 85, ctr: 7.08, position: 3.2 },
    { query: 'kilimanjaro hiking cost', impressions: 850, clicks: 42, ctr: 4.94, position: 2.1 },
    { query: 'serengeti migration best time', impressions: 600, clicks: 30, ctr: 5.0, position: 4.5 },
    { query: 'luxury zanzibar hotels', impressions: 450, clicks: 15, ctr: 3.33, position: 6.8 },
    { query: 'ngorongoro crater tours', impressions: 380, clicks: 22, ctr: 5.79, position: 1.9 }
];
export const MOCK_CRAWL_ERRORS: CrawlError[] = [];
export const MOCK_WEB_VITALS: CoreWebVitalsMetric[] = [];
export const MOCK_SEO_TRAFFIC: SeoTrafficPoint[] = [
    { date: 'Jan', traffic: 1200 },
    { date: 'Feb', traffic: 1400 },
    { date: 'Mar', traffic: 1100 },
    { date: 'Apr', traffic: 1600 },
    { date: 'May', traffic: 2100 },
    { date: 'Jun', traffic: 2400 },
    { date: 'Jul', traffic: 2300 }
];
export const MOCK_ANALYTICS_TRAFFIC: AnalyticsTrafficData[] = [];
export const MOCK_DEVICE_DATA: DeviceStat[] = [];
export const MOCK_TOP_PAGES: TopPageStat[] = [];
export const MOCK_FUNNEL_DATA: FunnelStep[] = [];
export const MOCK_USER_PATHS: UserPath[] = [];
export const MOCK_GEO_DATA: GeoStat[] = [];
export const MOCK_TRAINING_DOCS: TrainingDocument[] = [];
export const MOCK_CHAT_SESSIONS: UserChatSession[] = [];
export const MOCK_SCRAPING_JOBS: ScrapingJob[] = [];
export const MOCK_SYSTEM_UPDATES: SystemUpdate[] = [];
export const MOCK_CONTENT_CLUSTERS: BlogContentCluster[] = [];
export const MOCK_CONTENT_GAPS: BlogContentGap[] = [];
export const MOCK_ROLES: Role[] = [
    { id: 'r1', name: 'Super Admin', description: 'Total access', permissions: ['view_dashboard', 'manage_tours', 'manage_destinations', 'manage_customers', 'manage_bookings', 'manage_financials', 'manage_content', 'manage_seo', 'manage_users', 'manage_settings', 'use_ai_tools', 'manage_notifications', 'manage_license'], isSystem: true },
    { id: 'r2', name: 'Viewer', description: 'Read-only access', permissions: ['view_dashboard'], isSystem: false }
];
export const MOCK_ADMINS: AdminUser[] = [];
export const MOCK_GMB_ACCOUNTS: GmbAccount[] = [];
export const MOCK_EMAIL_TEMPLATES: EmailTemplate[] = [];
export const MOCK_BLOG_CATEGORIES: BlogCategory[] = [];
export const MOCK_AUTHORS: Author[] = [];
export const MOCK_GMB_LOCATIONS: GmbLocation[] = [];
export const MOCK_CITATIONS: LocalCitation[] = [];
export const MOCK_PASSENGERS: Passenger[] = [];
export const MOCK_TRIP_DOCUMENTS: TripDocument[] = [];
export const MOCK_NOTIFICATION_LOGS: NotificationLog[] = [];

export const MOCK_ANALYSIS_RESULTS = {
    metrics: [],
    keywordGap: [],
    backlinkGap: []
};


